import {BaseApiTemplateService, Core2Config} from "../../shared";
import {WfProjectUserContainerModel} from "../../../../../../models/aggregates/wf/project/wf-project-user-container.model";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class WfProjectUserService extends BaseApiTemplateService<WfProjectUserContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-user-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'project-user-links';
    this.httpClient = http;
  }
}
